// extracted by css-extract-rspack-plugin
module.exports =  {"message-container":"Message-aEVu__message-container"};